import type { IGetUserAutocompleteQuery } from "@api";
import { CircularProgress } from "@mui/material";
import type { ElementType } from "react";
import {
  AutocompleteAuthorsBase,
  type TAutocompleteAuthorsBaseProps,
  type TAutocompleteAuthorsValue,
} from "./autocomplete";
import { useAutocompleteAuthors } from "./logics";

type TAutocompleteAuthorsProps<
  Multiple extends boolean,
  DisableClearable extends boolean | undefined,
  ChipComponent extends ElementType = "div",
> = Omit<
  TAutocompleteAuthorsBaseProps<TAutocompleteAuthorsValue, Multiple, DisableClearable, ChipComponent>,
  "options" | "loading" | "onInputChange"
> & {
  permissions?: string[];
  query?: IGetUserAutocompleteQuery;
  teams?: boolean;
};
export const AutocompleteAuthors = <
  Multiple extends boolean,
  DisableClearable extends boolean | undefined,
  ChipComponent extends ElementType = "div",
>({
  permissions = ["filters.authors"],
  query,
  teams,
  ...props
}: TAutocompleteAuthorsProps<Multiple, DisableClearable, ChipComponent>) => {
  const { loading, options, loadOnOpen, getDebounceUser } = useAutocompleteAuthors(permissions, query, teams);

  return (
    <AutocompleteAuthorsBase
      {...props}
      loading={loading}
      loadingText={<CircularProgress color="primary" size={15} />}
      options={options}
      onOpen={loadOnOpen}
      onInputChange={getDebounceUser}
      teams={teams}
    />
  );
};
